

export default {
  name: 'vue-sound',
  props: {
    autoPlay: {
      type: Boolean,
      default: false
    },
    details: {
      type: String,
      default: null
    },
    detailsLink: {
      type: String,
      default: null
    },
    file: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: null
    },
    livestream: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    },
    showDownload: {
      type: Boolean,
      default: false
    },
    showSkip: {
      type: Boolean,
      default: true
    },
    showTrack: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: null
    },
    titleLink: {
      type: String,
      default: null
    },
    volumeChange: {
      type: Boolean,
      default: true
    },
    keyControls: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      audio: undefined,
      currentSeconds: 0,
      durationSeconds: 0,
      buffered: 0,
      innerLoop: false,
      loaded: false,
      playing: false,
      previousVolume: 35,
      showVolume: false,
      volume: 100
    }
  },
  computed: {
    hasDetails () {
      return this.$props.details
    },
    hasDetailsLink () {
      return this.$props.detailsLink
    },
    hasTitle () {
      return this.$props.title
    },
    hasTitleLink () {
      return this.$props.titleLink
    },
    muted () {
      return this.volume / 100 === 0
    },
    percentBuffered () {
      return ( this.buffered / this.durationSeconds ) * 100
    },
    percentComplete () {
      return ( this.currentSeconds / this.durationSeconds ) * 100
    },
    listeners(){
      return this.keyControls ? {keydown: this.onKeyDown} : {}
    }
  },
  watch: {
    playing ( value ) {
      if ( value ) {
        return this.audio.play()
      }
      this.audio.pause()
    },
    volume () {
      this.audio.volume = this.volume / 100
    }
  },
  created () {
    this.innerLoop = this.loop
    // keyboard accessibility
    if (this.keyControls) {
      window.addEventListener('keydown', this.onKeyDown)
    }
  },
  beforeUnmount(){
    window.removeEventListener('keydown', this.onKeyDown)
  },
  mounted () {
    this.audio = this.$refs.audioFile
    this.audio.addEventListener( 'timeupdate', this.update )
    this.audio.addEventListener( 'loadeddata', this.load )
    this.audio.addEventListener( 'buffered', this.update )
    this.audio.addEventListener( 'pause', () => {
      this.playing = false
    } )
    this.audio.addEventListener( 'play', () => {
      this.playing = true
    } )
  },
  methods: {
    onKeyDown(event){
      switch (event.code) {
        case 'Space':
        case 'Enter':
          this.togglePlay()
          break
        case 'ArrowUp':
          if (this.volume < 100) this.volume++
          break
        case 'ArrowDown':
          if (this.volume > 0) this.volume--
          break
        case 'ArrowLeft':
          this.goBack15()
          break
        case 'ArrowRight':
          this.goAhead15()
          break
      }
    },
    convertTimeHHMMSS ( val ) {
      const hhmmss = new Date( val * 1000 ).toISOString().substr( 11, 8 )
      return hhmmss.indexOf( '00:' ) === 0 ? hhmmss.substr( 3 ) : hhmmss
    },
    download () {
      this.stop()
      window.open( this.file, 'download' )
    },
    goAhead15 () {
      this.audio.currentTime = this.audio.currentTime + 15
    },
    goBack15 () {
      this.audio.currentTime = this.audio.currentTime - 15
    },
    load () {
      if ( this.audio.readyState >= 2 ) {
        this.loaded = true
        this.durationSeconds = parseInt( this.audio.duration )
        this.playing = this.autoPlay
        return this.playing
      }
      throw new Error( 'Failed to load sound file.' )
    },
    mute() {
      if (this.muted) {
        this.volume = this.previousVolume
        return this.volume
      }
      this.previousVolume = this.volume
      this.volume = 0
    },
    seek(ev) {
      if (!this.loaded) return
      const el = this.$refs.progress.getBoundingClientRect()
      const seekPos = (ev.clientX - el.left) / el.width
      this.audio.currentTime = parseInt(this.audio.duration * seekPos)
    },
    stop () {
      this.playing = false
      this.audio.currentTime = 0
    },
    togglePlay () {
      this.playing = !this.playing
    },
    update () {
      this.currentSeconds = this.audio.currentTime
      this.buffered = this.audio.buffered.end(0)
    }
  }
}
